import React, { Component } from "react";

import Head from "./_officeHead";
import Sidebar from "./_officeSidebar";
import Footer from "./_footer";

export default class OfficeLayout extends Component {
  render() {
    return (
      <div>
        <div className={"content main-content"}>
          <div className="office">
            <Head />
            <div className="office-body">
              <div className="container body-container">
                <Sidebar />
                <div className="office-content">{this.props.children}</div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/layout/office.jsx